import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { BrandImagesProvider } from './lib/BrandImagesContext';
import SiteLayout from './components/layout/SiteLayout';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import MissionVisionPage from './pages/MissionVisionPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import ContactPage from './pages/ContactPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminOverviewPage from './pages/admin/AdminOverviewPage';
import AdminLeadsPage from './pages/admin/AdminLeadsPage';
import AdminBlogPage from './pages/admin/AdminBlogPage';
import AdminBlogEditPage from './pages/admin/AdminBlogEditPage';
import AdminContentPage from './pages/admin/AdminContentPage';
import AdminGalleryPage from './pages/admin/AdminGalleryPage';
import AdminSEOPage from './pages/admin/AdminSEOPage';
import AdminAnalyticsPage from './pages/admin/AdminAnalyticsPage';
import AdminBrandImagesPage from './pages/admin/AdminBrandImagesPage';

function App() {
    useEffect(() => {
        document.documentElement.classList.add('dark');
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <BrandImagesProvider>
                    <Routes>
                        <Route element={<SiteLayout />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/services" element={<ServicesPage />} />
                            <Route path="/mission" element={<MissionVisionPage />} />
                            <Route path="/blog" element={<BlogPage />} />
                            <Route path="/blog/:slug" element={<BlogDetailPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                        </Route>
                        <Route path="/admin" element={<AdminLoginPage />} />
                        <Route element={<AdminLayout />}>
                            <Route path="/admin/dashboard" element={<AdminOverviewPage />} />
                            <Route path="/admin/leads" element={<AdminLeadsPage />} />
                            <Route path="/admin/blog" element={<AdminBlogPage />} />
                            <Route path="/admin/blog/new" element={<AdminBlogEditPage mode="new" />} />
                            <Route path="/admin/blog/:slug" element={<AdminBlogEditPage mode="edit" />} />
                            <Route path="/admin/content" element={<AdminContentPage />} />
                            <Route path="/admin/gallery" element={<AdminGalleryPage />} />
                            <Route path="/admin/brand-images" element={<AdminBrandImagesPage />} />
                            <Route path="/admin/seo" element={<AdminSEOPage />} />
                            <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrandImagesProvider>
            </BrowserRouter>
            <Toaster
                position="top-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: 'rgba(10, 14, 22, 0.92)',
                        border: '1px solid rgba(0, 229, 255, 0.32)',
                        color: '#e6f9ff',
                    },
                }}
            />
        </div>
    );
}

export default App;
